import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import Batuk from "../../assets/images/new/fav-removebg-preview.png";
import { LoaderContext } from "../../AuthContext/AuthContext";
import banner from '../../assets/images/new/orderPageBanner.png'
import PujaAtTempleBannerImg from "../../assets/images/new/PujaAtTempleBannerImg.png";

const PujaKitSubscriptionOrders = () => {
    const userID = JSON.parse(localStorage.getItem("userID"));
    const [orders, setOrders] = useState([]);
    const navigate = useNavigate();
    const { setLoader, loader } = useContext(LoaderContext);
    useEffect(() => {
        setLoader(true)
        axios
            .post(`${BaseUrl}/UserWisePujaKitSubscriptionPlanBookingList?UserID=${userID}`, {
                START: 1,
                END: 100,

            })
            .then((response) => {
                console.log("Response...", response.data.DATA);
                setOrders(response.data.DATA);
                setLoader(false)
            });
    }, []);

    const orderDetails = (myorders) => {
        navigate("/puja-kit-order-details", { state: myorders });
    };

    function formatToIndianCurrency(amount) {
        if (!amount) return "";

        const [integerPart, decimalPart] = amount.toString().split(".");

        // Format the integer part using Indian numbering system
        const formattedIntegerPart = integerPart.replace(
            // Match groups of 3 digits initially, then groups of 2 digits
            /(\d)(?=(\d\d)+\d$)/g,
            "$1,"
        );

        // Return the formatted value with the decimal part (if present)
        return decimalPart !== undefined
            ? `${formattedIntegerPart}.${decimalPart}`
            : formattedIntegerPart;
    }
    return (
        <>
            <section className="page-header">
                <div className="page-header__bg" style={{ backgroundImage: `url(${PujaAtTempleBannerImg})` }}></div>
                <div className="container" >
                    <h2 className="page-header__title bw-split-in-left">Puja Kit Subscription Orders</h2>
                </div>
            </section>
            <div className="p-3 m-4 my-4">
                {orders?.length > 0 ? (
                    <div className="row gx-4 gy-4" style={{ justifyContent: 'left' }}>
                        {orders.map((order) => (
                            <div className="col-xl-4 col-lg-4 col-md-6" key={order.id}>
                                <div
                                    className="card border-0 shadow-lg p-2 h-100"
                                    onClick={() => orderDetails(order)}
                                    style={{ cursor: "pointer" }}
                                >
                                    <div className="d-flex align-items-start">
                                        <img
                                            src={order?.PAT_IMAGE || Batuk}
                                            alt={order.PAT_NAME}
                                            className="rounded me-3"
                                            style={{ width: "100px", height: "100px", objectFit: "contain" }}
                                        />
                                        {/* Flex column wrapper */}
                                        <div className="d-flex flex-column justify-content-between w-100" style={{ minHeight: '100px' }}>
                                            <div style={{ height: '7em' }}>
                                                <h6
                                                    className="mb-1 text-truncate"
                                                    style={{
                                                        whiteSpace: "normal",
                                                        wordBreak: "break-word",
                                                    }}
                                                    title={order.Title}
                                                >
                                                    {order.Title} Subscription
                                                </h6>
                                                <span className="fw-bold text-muted">#{order.BookingID}</span>
                                                <p className="mb-1">
                                                    <strong>Payment Status:</strong>{" "}
                                                    <span
                                                        style={{
                                                            color: order.PaymentStatus === "Pending" ? "red" : "green",
                                                            fontWeight: "600",
                                                        }}
                                                    >
                                                        {order.PaymentStatus}
                                                    </span>
                                                </p>
                                                <p className="mb-1 fw-bold">
                                                    <strong>Total Amount:</strong> ₹{" "}
                                                    {formatToIndianCurrency(Number(order?.PujaKitPrice))}
                                                </p>
                                            </div>

                                            {/* Button always at bottom */}
                                            <div className="mt-3">
                                                <button
                                                    className="Normal-app-btn"
                                                    style={{
                                                        padding: "5px 10px",
                                                        fontSize: "12px",
                                                    }}
                                                >
                                                    View Details
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        ))}
                    </div>
                ) : loader === false ? (
                    <div className="d-flex flex-column align-items-center justify-content-center vh-90 text-center mt-4">
                        <img
                            src={Batuk}
                            alt="Empty Cart"
                            className="img-fluid mb-3"
                            style={{ maxWidth: "250px" }}
                        />
                        <h5 className="fw-bold">No orders found</h5>
                        <button
                            className="careox-btn"
                            style={{ cursor: "pointer" }}
                            onClick={() => navigate("/services/puja-booking")}
                        >
                            Book now
                        </button>
                    </div>
                ) : (
                    ""
                )}
            </div>
        </>
    )
}

export default PujaKitSubscriptionOrders
